<template>
  <div class="relative">
    <exercise-logic
      :exCollection="$route.meta.model"
      :saveState="saveState"
      @ready="onReady"
      @error="onError"
      @saved="onSaved"
      @savedNext="onSavedNext"
      @loadedEx="onLoadedEx"
      :doc="doc"
      :shared="false"
      :pid="false"
    >
      <template slot-scope="{ saveExercise }">
        <v-row>
          <v-col cols="4" class="mb-4">
            <h2 v-text="$t(`${$route.meta.content}.step1.title`)"></h2>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="8">
            <div v-if="showStreamField" class="d-flex flex-row align-center">
              <v-text-field
                label="Stream"
                v-model.trim="doc.stream"
                type="text"
                placeholder="e.g. Post Graduate Recruitment"
                id="title"
                class="display-1"
              ></v-text-field>

              <v-btn
                color="amber"
                class="black--text"
                @click="editStream = false"
              >
                Done
              </v-btn>
            </div>
            <div v-else>
              <p class="mb-0">Stream</p>
              <div class="mb-10 d-flex flex-row align-center">
                <h1>{{ doc.stream }}</h1>
                <v-icon @click="editStream = true" class="white--text ml-10"
                  >mdi-pencil</v-icon
                >
              </div>
            </div>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="6" class="">
            <p
              v-for="(item, index) in $t(
                `${$route.meta.content}.step1.description`
              )"
              :key="index"
              v-text="item"
            />
          </v-col>
          <v-col cols="4">
            <p>Stream</p>
            <v-text-field
              label="Which group is this for?"
              v-model.trim="doc.stream"
              type="text"
              placeholder="Type here"
              id="title"
              class="title"
              required
              color="amber"
            ></v-text-field>
          </v-col>
          <v-col cols="8"> </v-col>
          <v-col cols="12">
            <v-btn light class="amber" @click="addNote">Add Card</v-btn>
          </v-col>
        </v-row>

        <div class="service mt-5">
          <service-col-user
            v-model="doc.list1"
            name="list1"
            title="Planning"
            class="service__col"
            @editNote="editNote"
            @showNote="showNote"
            @handleEnd="handleEnd"
          ></service-col-user>
          <service-col-user
            v-model="doc.list2"
            name="list2"
            title="Arrival"
            class="service__col"
            @editNote="editNote"
            @showNote="showNote"
            @handleEnd="handleEnd"
          ></service-col-user>
          <service-col-user
            v-model="doc.list3"
            name="list3"
            title="Orientation"
            class="service__col"
            @editNote="editNote"
            @showNote="showNote"
            @handleEnd="handleEnd"
          ></service-col-user>
          <service-col-user
            v-model="doc.list4"
            name="list4"
            title="Get"
            class="service__col"
            @editNote="editNote"
            @showNote="showNote"
            @handleEnd="handleEnd"
          ></service-col-user>
          <service-col-user
            v-model="doc.list5"
            name="list5"
            title="Leave"
            class="service__col"
            @editNote="editNote"
            @showNote="showNote"
            @handleEnd="handleEnd"
          ></service-col-user>
          <service-col-user
            v-model="doc.all"
            name="all"
            title="Inbox"
            class="service__tray"
            @editNote="editNote"
            @showNote="showNote"
            @handleEnd="handleEnd"
          ></service-col-user>
        </div>

        <v-row v-if="debug">
          <v-col cols="2">
            <p>All</p>
            <pre>{{ doc.all }}</pre>
            <p>Doc</p>
            <pre>{{ doc }}</pre>
          </v-col>
        </v-row>

        <bottom-navigation
          :save="true"
          :next="false"
          :prev="false"
          :gridView="false"
          :gridToggle="false"
          @save="saveExercise(true)"
          @prev="prevStep"
          @next="nextStep"
        >
        </bottom-navigation>
      </template>
    </exercise-logic>

    <v-dialog v-model="dialog" max-width="500">
      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add item</v-card-title>

        <v-card-text>
          <service-add-user
            @complete="closeDialog"
            @saveNote="saveNote"
            @cancel="cancel"
            v-model="item"
            :edit="false"
          />
        </v-card-text>
      </v-card>

      <v-card v-else-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <service-show-user
            v-model="item"
            :key="cardId"
            @complete="closeDialog"
          />
        </v-card-text>
      </v-card>

      <v-card v-else-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit item</v-card-title>

        <v-card-text>
          <service-add-user
            @complete="closeDialog"
            @updateNote="updateNote"
            @cancel="cancel"
            v-model="item"
            :edit="true"
            :key="cardId"
          />
        </v-card-text>
      </v-card>

      <v-card v-else>
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
const defaults = {
  title: "",
  categories: [],
  subitems: [],
  model: "all",
  description: "",
};

import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ServiceColUser, ServiceAddUser, ServiceShowUser } from "./service";
import { ExerciseLogic } from "@/components/exercises";

export default {
  name: "UserServiceUser",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "",
      debug: false,
      item: { ...defaults },
      editStream: false,
      saveState: false,
      autoSave: true,
      doc: {
        stream: "",
        list1: [],
        list2: [],
        list3: [],
        list4: [],
        list5: [],
        all: [],
      },
      cardId: null,
      cardIndex: 0,
      cardModel: "all",
      all: [],
    };
  },
  components: {
    BottomNavigation,
    ServiceColUser,
    ServiceAddUser,
    ServiceShowUser,
    ExerciseLogic,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    showStreamField() {
      return this.editStream;
    },
  },
  methods: {
    nextStep() {
      this.e1++;
      console.log("next step");
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved exercise");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedEx(items) {
      console.log("loaded", items);
      if (items) {
        this.doc = items.doc;
      }
    },
    onSavedNext() {
      this.saveState = false;
    },
    addNote() {
      this.item = { ...defaults };
      this.$set(this.item, "subitems", []);
      this.dialogMode = "add";
      this.dialog = true;
    },
    editNote(params) {
      this.setItem(params);
      this.dialogMode = "edit";
      this.dialog = true;
    },
    showNote(params) {
      this.setItem(params);
      this.dialogMode = "show";
      this.dialog = true;
    },
    setItem(params) {
      const item = this.doc[params.name].find((x) => x.id === params.id);
      this.cardIndex = this.doc[params.name].indexOf(item);
      this.cardId = params.id;
      this.cardModel = params.name;
      this.item = Object.assign({}, item);
      this.item.model = params.name;
    },
    cancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
      this.item = { ...defaults };
      this.$set(this.item, "subitems", []);
    },
    saveNote(ref) {
      const newItem = {
        id: new Date().valueOf(),
        ...ref,
      };
      if (ref.model !== "") {
        this.doc[ref.model].push(newItem);
      } else {
        this.doc.all.push(newItem);
      }
      this.closeDialog();
      this.doAutoSave();
    },
    updateNote(ref) {
      // check to see if old model === updated model
      if (ref.model !== this.cardModel) {
        this.doc[this.cardModel].splice(this.cardIndex, 1);
        this.doc[ref.model].push(ref);
      } else {
        this.$set(this.doc[this.cardModel], this.cardIndex, ref);
      }
      this.closeDialog();
      this.doAutoSave();
    },
    handleEnd() {
      this.doAutoSave();
    },
    doAutoSave() {
      if (this.autoSave) {
        this.saveState = true;
      }
    },
  },
};
</script>
